import { useContext } from 'react';
import { RTLContext } from './rtl';
import { css } from 'styled-components';

const RTL_LANGUAGES = new Set(['ar', 'he', 'fa', 'ur', 'yi']);

export const isRTLLanguage = (languageCode: string): boolean => {
    const normalized = languageCode.toLowerCase().split('-')[0];
    return RTL_LANGUAGES.has(normalized);
};

export const useRTL = () => useContext(RTLContext);

export const rtl = (rtlStyles: ReturnType<typeof css>, ltrStyles?: ReturnType<typeof css>) => css`
    [dir='rtl'] & {
        ${rtlStyles}
    }
    ${ltrStyles &&
    css`
        [dir='ltr'] & {
            ${ltrStyles}
        }
    `}
`;
